/**
 * Collection "View more" - reveal hidden cards in batches; fetch next page when all are revealed
 */
(function () {
  function init(container) {
    const trigger = container.querySelector('[data-view-more-trigger]');
    const grid = document.getElementById('product-grid');
    if (!trigger || !grid) return;

    const cardsPerPage = parseInt(container.dataset.cardsPerPage || '15', 10);
    let totalCards = parseInt(container.dataset.totalCards || '0', 10);
    let visibleCount = cardsPerPage;
    let currentPage = parseInt(container.dataset.currentPage || '1', 10);
    const totalPages = parseInt(container.dataset.totalPages || '1', 10);

    function setVisibleCount(count) {
      visibleCount = count;
      const cards = grid.querySelectorAll('.collection-card[data-card-index]');
      cards.forEach(function (card) {
        const index = parseInt(card.getAttribute('data-card-index'), 10);
        if (index < visibleCount) {
          card.classList.remove('collection-card--hidden');
        } else {
          card.classList.add('collection-card--hidden');
        }
      });
      if (visibleCount >= totalCards && currentPage >= totalPages) {
        container.classList.add('hidden');
      } else {
        container.classList.remove('hidden');
      }
    }

    if (totalCards <= cardsPerPage && currentPage >= totalPages) {
      container.classList.add('hidden');
    }

    trigger.addEventListener('click', function () {
      const nextVisible = visibleCount + cardsPerPage;

      if (nextVisible <= totalCards) {
        setVisibleCount(nextVisible);
        return;
      }

      if (currentPage < totalPages) {
        const label = trigger.querySelector('.collection-view-more__label');
        const spinner = trigger.querySelector('.collection-view-more__spinner');
        if (label) label.classList.add('hidden');
        if (spinner) spinner.classList.remove('hidden');
        trigger.disabled = true;

        const url = new URL(window.location.href);
        url.searchParams.set('page', String(currentPage + 1));

        fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (response) { return response.text(); })
          .then(function (html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const nextGrid = doc.getElementById('product-grid');
            if (!nextGrid || !nextGrid.innerHTML.trim()) {
              if (label) label.classList.remove('hidden');
              if (spinner) spinner.classList.add('hidden');
              trigger.disabled = false;
              return;
            }

            const newCards = nextGrid.querySelectorAll('.collection-card[data-card-index]');
            const startIndex = totalCards;
            newCards.forEach(function (card, i) {
              const newLi = card.cloneNode(true);
              const newIndex = startIndex + i;
              newLi.setAttribute('data-card-index', newIndex);
              newLi.classList.add('collection-card--hidden');
              grid.appendChild(newLi);
            });
            totalCards = startIndex + newCards.length;
            container.dataset.totalCards = String(totalCards);
            currentPage = currentPage + 1;
            container.dataset.currentPage = String(currentPage);

            var promoCards = grid.querySelectorAll('.promo-banner-card');
            if (promoCards.length > 1) {
              for (var p = 1; p < promoCards.length; p++) {
                if (promoCards[p].parentNode) promoCards[p].parentNode.removeChild(promoCards[p]);
              }
              totalCards = grid.querySelectorAll('.collection-card[data-card-index]').length;
              container.dataset.totalCards = String(totalCards);
            }

            setVisibleCount(visibleCount + cardsPerPage);
          })
          .catch(function () {
            if (label) label.classList.remove('hidden');
            if (spinner) spinner.classList.add('hidden');
            trigger.disabled = false;
          })
          .finally(function () {
            if (label) label.classList.remove('hidden');
            if (spinner) spinner.classList.add('hidden');
            trigger.disabled = false;
          });
      } else {
        setVisibleCount(totalCards);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-view-more]').forEach(init);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('[data-view-more]');
    if (container) init(container);
  });
})();
